import React from "react";
import {
  List,
  ListItem,
  FormControl,
  TextField,
  Stack,
  Button,
  Select,
  MenuItem,
  InputLabel,
  DialogContent,
  Typography,
} from "@mui/material";
import DistrictAutocomplete from "./DistrictAutocomplete";
import axios from "axios";
import * as settings from "../../settings";
import PlanFormColorSelect from "./PlanFormColorSelect";
const fieldStyles = { paddingBottom: "1rem" };
const inputStyle = { fontWeight: 900, fontSize: "28px" };
const listItemStyles = {
  display: "flex",
  flexDirection: "column",
  textAlign: "left",
};

export default class NewPlanForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user_id: localStorage.getItem("username"),
      title: null,
      district: null,
      analysis: "",
      color: "#dedede",
      triedToSubmit: false,
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleClose = () => {
    this.props.onClose();
  };

  handleInputChange({ name, value }) {
    this.setState({
      [name]: value,
    });
  }

  handleSubmit(event) {
    if (!this.state.title || !this.state.district || !this.state.analysis) {
      this.handleInputChange({ name: "triedToSubmit", value: true });
    } else {
      axios
        .post(`${settings.API_SERVER}/api/new_plan/`, this.state)
        .then((res) => {
          this.props.setPlan(res.data.plan_id);
          // TODO: set plan to new plan, rerender Plans component (add Plan to dependency array)
          // OR??? redirect to analysis page
        })
        .catch((err) => console.log("error posting new plan", err)); // should do something: display error message as popup
      this.handleClose();
    }
  }

  render() {
    return (
      <>
        <PlanFormColorSelect
          handleInputChange={this.handleInputChange}
          defaultColor={this.state.color}
        />
        <DialogContent sx={{ paddingTop: "0" }}>
          <List>
            <ListItem sx={listItemStyles}>
              <TextField
                id="title"
                hiddenLabel
                placeholder="Analysis name"
                variant="standard"
                sx={fieldStyles}
                inputProps={{ style: inputStyle }}
                onChange={(event) =>
                  this.handleInputChange({
                    name: event.target.id,
                    value: event.target.value,
                  })
                }
              />
              {this.state.triedToSubmit && !this.state.title ? (
                <Typography variant="body2" color="error">
                  Please add a title
                </Typography>
              ) : null}
            </ListItem>
            <ListItem sx={listItemStyles}>
              <FormControl
                variant="filled"
                size="small"
                fullWidth
                required={true}
                sx={fieldStyles}
              >
                <DistrictAutocomplete
                  handleInputChange={this.handleInputChange}
                />
              </FormControl>
              {this.state.triedToSubmit && !this.state.district ? (
                <Typography variant="body2" color="error">
                  Please select a District
                </Typography>
              ) : null}
            </ListItem>
            <ListItem sx={listItemStyles}>
              <FormControl fullWidth required={true}>
                <InputLabel id="analysis-type-select-label">
                  Analysis type
                </InputLabel>
                <Select
                  id="analysis"
                  value={this.state.analysis}
                  variant="outlined"
                  label="Analysis type"
                  default={this.state.analysis}
                  onChange={(event) =>
                    this.handleInputChange({
                      name: "analysis",
                      value: event.target.value,
                    })
                  }
                >
                  <MenuItem value={"explore"} disabled>
                    Exploration
                  </MenuItem>
                  <MenuItem default value={"redistrict"}>
                    Redistricting
                  </MenuItem>
                  <MenuItem value={"project"} disabled>
                    Enrollment projection
                  </MenuItem>
                </Select>
              </FormControl>
              {this.state.triedToSubmit && !this.state.analysis ? (
                <Typography variant="body2" color="error" pt="16px">
                  Please select an analysis type
                </Typography>
              ) : null}
            </ListItem>
            <ListItem>
              <Stack direction="row" spacing={1} mt={4}>
                <Button
                  type="submit"
                  variant="filled"
                  onClick={this.handleSubmit}
                  sx={{
                    backgroundColor: "grey.medium",
                    "&:hover": {
                      backgroundColor: "grey.dark",
                      transition: ".3s",
                    },
                  }}
                >
                  Submit
                </Button>
                <Button onClick={this.handleClose} variant="outlined">
                  Cancel
                </Button>
              </Stack>
            </ListItem>
          </List>
        </DialogContent>
      </>
    );
  }
}
